export type SKU = string & { __brand: 'SKU' };
export const sku = (s: string): SKU => s as SKU;

export type ProductCategory =
  | 'platform'
  | 'tread'
  | 'rail'
  | 'support'
  | 'accessory'
  | 'ramp-portable'
  | 'passe-seuil'
  | 'marche';

export type Usage = 'res' | 'com' | 'both';
export type Floor = 'plein' | 'mailles';

export interface Dimensions {
  widthIn?: number;
  lengthIn?: number;
  heightIn?: number;
  /** Extended dimension: thickness (e.g. plate thickness). */
  thicknessIn?: number;
  /** Extended dimension: diameter (e.g. round bar). */
  diameterIn?: number;
}
export interface ProductPricing {
  costCad: number;
  sellCad: number;
}
export interface BomLine {
  partSku: SKU;
  quantity: number;
  description: string;
}

export interface Product {
  sku: SKU;
  category: ProductCategory;
  subCategory?: string;
  descriptionFr: string;
  descriptionEn: string;
  dimensions?: Dimensions;
  usage: Usage;
  pricing: ProductPricing;
  taxable: boolean;
  availableFloors: Floor[];
  parts?: BomLine[];

  // === Enrichments (PDF metadata / parts inventory / image manifest) ===
  /** Weight in pounds (from PDF metadata or parts inventory). */
  weightLbs?: number;
  /** Weight in kilograms (parts inventory only). */
  weightKg?: number;
  /** Material grade (e.g. "6005A-T61"). */
  material?: string;
  /** ISO date YYYY-MM-DD of the technical drawing (from PDF title block). */
  drawingDate?: string;
  /** Revision number (0, 1, 2, ...). */
  revision?: number;
  /** Drawing scale (e.g. "1:12"). */
  scale?: string;
  /** Drawn-by initials (e.g. "CH.BROCHU"). */
  drawnBy?: string;
  /** Relative URL of the thumbnail/image (e.g. "/assets/parts/F01005.png"). */
  imageUrl?: string;
}

export interface Bundle {
  sku: SKU;
  descriptionFr: string;
  subProducts: SKU[];
}

export interface PriceRules {
  installationPerSqFt: { width36: number; width48: number };
  uninstallationPerSqFt: { width36: number; width48: number };
  transportPerKm: { withUninstall: number; withoutUninstall: number };
  rentalMonthlyDivisor: 15;
  rentalBuybackPct: 0.2;
  taxes: { tps: 0.05; tvq: 0.09975 };
}

export interface CatalogSourceMeta {
  source: 'master-rose' | 'hubspot' | 'qbo';
  importedAt: string;
  xlsxHash: string;
}

export interface Catalog {
  readonly schemaVersion: '1.0';
  readonly sourceMeta: CatalogSourceMeta;
  readonly products: ReadonlyMap<SKU, Product>;
  readonly bundles: ReadonlyMap<SKU, Bundle>;
  readonly priceRules: PriceRules;
}
